import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect, useRef } from 'react';
import * as gTag from '../utils/gTag';

const GoogleAnalytics: React.FC = () => {
  const router = useRouter();
  const prevPath = useRef<string>('');

  useEffect(() => {
    // Track page views on route change
    const handleRouteChange = (url: string) => {
      if (prevPath.current !== url && gTag.GA_TRACKING_ID) {
        gTag.pageview(url, document.title);
        prevPath.current = url;
      }
    };

    // Track initial page load
    if (prevPath.current !== router.asPath && gTag.GA_TRACKING_ID) {
      gTag.pageview(router.asPath, document.title);
      prevPath.current = router.asPath;
    }

    // Subscribe to route changes
    router.events.on('routeChangeComplete', handleRouteChange);

    // Cleanup event listener
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events, router.asPath]);

  if (!gTag.GA_TRACKING_ID) {
    return null;
  }

  return (
    <>
      <Script strategy="afterInteractive" src={`https://www.googletagmanager.com/gtag/js?id=${gTag.GA_TRACKING_ID}`} />
      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gTag.GA_TRACKING_ID}', {
              page_path: window.location.pathname,
            });
          `
        }}
      />
    </>
  );
};

export default GoogleAnalytics;
